import { useState, useEffect } from "react";
import NavbarDesktop from "./navbar-desktop";
import NavbarMobile from "./navbar-mobile";

interface NavbarProps extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  ref?: React.Ref<HTMLElement>;
}

export function Navbar({ className, ref, ...props }: NavbarProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile ? (
    <NavbarMobile ref={ref} className={className} {...props} />
  ) : (
    <NavbarDesktop ref={ref} className={className} {...props} />
  );
}

export default Navbar;
